// Autosave the single-player match (Settings → Gameplay → Autosave), and offer
// the newest autosave as "Continue" on the menu. Extracted from App.tsx
// (ROADMAP 7.14); the hook order is unchanged.

import { useEffect, useState } from 'react';
import type { GameMode } from '../multiplayer/lobby/shouldConnectMpLobby.js';
import { type AutosaveEntry, latestAutosave } from '../save/autosaveStore.js';
import { useAutosave } from '../save/useAutosave.js';
import { useSettings } from '../settings/useSettings.js';
import type { SimWorld } from '../sim/useSimWorld/index.js';

export function useContinueSave(sim: SimWorld, gameMode: GameMode) {
  const autosaveEnabled = useSettings((s) => s.autosaveEnabled);
  useAutosave({
    enabled:
      autosaveEnabled && gameMode === 'single' && sim.status === 'ready' && sim.victory === null,
    tick: Number(sim.tick ?? 0),
    saveGame: sim.saveGame,
  });
  const [continueSave, setContinueSave] = useState<AutosaveEntry | null>(null);
  const [pendingLoad, setPendingLoad] = useState<string | null>(null);
  useEffect(() => {
    if (gameMode !== 'menu') return;
    let live = true;
    void latestAutosave().then((s) => {
      if (live) setContinueSave(s);
    });
    return () => {
      live = false;
    };
  }, [gameMode]);
  useEffect(() => {
    if (!pendingLoad || sim.status !== 'ready') return;
    try {
      sim.loadGame(pendingLoad);
    } catch (err) {
      console.error('Continue: loading the autosave failed', err);
    }
    setPendingLoad(null);
  }, [pendingLoad, sim.status, sim.loadGame]);

  return { continueSave, setPendingLoad };
}
